import React from 'react';
import { AlgoRerunDto, Consortium, Sample } from '@cambridgeassessment/lib-ee-commons';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db/entries';
import { ExpandableCardStyled, StyledSampleCardWrapper } from '../ManageSampleChanges.styles';
import { SampleSearchParams } from '../../../../store/samplesManagement/types';
import Loader from '../../../../components/Loader/Loader';
import { SampleCardContent } from './SampleCardContent';
import { TableSortConfig } from '../helpers';

interface Props {
  isSampleLoading: boolean;
  sample: Sample | undefined;
  setIsModalOpened: (value: boolean) => void;
  sampleSearchParams: SampleSearchParams | undefined;
  consortium: Consortium | undefined;
  sortConfig: TableSortConfig | undefined;
  setSortConfig: (val: TableSortConfig | undefined) => void;
  onReplaceClick: (clickedLearner: Entry) => void;
  onRerunClick: () => void;
  algoReruns: AlgoRerunDto[];
}

export const SampleCardWrapper = (props: Props): JSX.Element | null => {
  const {
    isSampleLoading,
    sample,
    consortium,
    sampleSearchParams,
    setIsModalOpened,
    setSortConfig,
    sortConfig,
    onReplaceClick,
    onRerunClick,
    algoReruns,
  } = props;

  const showLoader = isSampleLoading && !sample;

  if (showLoader) {
    return <Loader />;
  }

  return sample?.wholeSample && sample.wholeSample.length > 0 ? (
    <StyledSampleCardWrapper>
      <ExpandableCardStyled
        expanded={false}
        summary={
          <SampleCardContent
            isLoading={isSampleLoading}
            sample={sample}
            onAddClick={() => setIsModalOpened(true)}
            inputsStates={sampleSearchParams}
            consortium={consortium}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
            onReplaceClick={onReplaceClick}
            onRerunClick={onRerunClick}
            algoReruns={algoReruns}
          />
        }
      />
    </StyledSampleCardWrapper>
  ) : null;
};
